/**
 * MotoristaMensagemPush
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Motorista} from '@/model/resource/Motorista'
import {Responsavel} from '@/model/resource/Responsavel'
import {MotoristaMensagemPushCollection} from '@/model/collection/MotoristaMensagemPushCollection'

/* TODO: review generated class */
export class MotoristaMensagemPush extends Resource {
  idMensagemPk: number = 0

  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  mensagem: string | null = null
  data: string | null = null
  ativo: boolean | null = null

  lida: boolean | null = null

  get $id() {
    return this.idMensagemPk
  }
  set $id(val) {
    this.idMensagemPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }
  set idMotoristaFk(val) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = val
  }

  /**
   * Lists the instances of MotoristaMensagemPush
   */
  static async listMotoristaMensagemPush(params: any) {
    return await Request.get(`/admin/motorista-mensagem-push`, {params})
      .name('listMotoristaMensagemPush')
      .as(MotoristaMensagemPushCollection)
      .getData()
  }

  /**
   * Persists a new instance of MotoristaMensagemPush. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistMotoristaMensagemPush() {
    return await Request.post(`/admin/motorista-mensagem-push`, this)
      .name('persistMotoristaMensagemPush')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of MotoristaMensagemPush to use it in a CSV file
   */
  static async listCsvMotoristaMensagemPush(params: any) {
    return await Request.get(`/admin/motorista-mensagem-push/csv`, {params})
      .name('listCsvMotoristaMensagemPush')
      .as(MotoristaMensagemPushCollection)
      .getData()
  }

  /**
   * Gets a instance of a given ID of MotoristaMensagemPush
   */
  async getMotoristaMensagemPush(id: number) {
    return await Request.get(`/admin/motorista-mensagem-push/${id}`)
      .name('getMotoristaMensagemPush')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of MotoristaMensagemPush
   */
  async removeMotoristaMensagemPush() {
    return await Request.delete(`/admin/motorista-mensagem-push/${this.$id}`)
      .name('removeMotoristaMensagemPush')
      .asNumber()
      .getData()
  }
}
